import hash from 'object-hash';

export function calculateInputHash(inputs: any): string {
  return hash(inputs);
}

export const calculationMetadata: Record<
  ClientCalculationType,
  ClientCalculationMetaDef
> = {
  allPhaseCosts: {
    calculationType: 'allPhaseCosts',
    version: '1.0',
    getInputs: client => ({
      phaseCosts: client.phaseCosts,
    }),
    getResult: client => ({
      ...client.allPhaseCosts,
    }),
  },
  combinedFundingSources: {
    calculationType: 'combinedFundingSources',
    version: '1.0',
    getInputs: client => ({
      fundingSources: client.fundingSources,
      multipleFundingSources: client.multipleFundingSources,
      policyPhaseCalculations: client.policyPhaseCalculations,
    }),
    getResult: client => ({
      combinedFundingTotalCost: client.fundingSources.combinedFundingTotalCost,
      combinedNonLtcPayout: client.fundingSources.combinedNonLtcPayout,
      combinedTotalValue: client.fundingSources.combinedTotalValue,
      combinedProjectedReturnOnInvestment:
        client.fundingSources.combinedProjectedReturnOnInvestment,
      combinedProjectedCompoundAnnualGrowthRate:
        client.fundingSources.combinedProjectedCompoundAnnualGrowthRate,
      combinedProjectedInternalRateOfReturn:
        client.fundingSources.combinedProjectedInternalRateOfReturn,
      combinedInvestmentPeriodYears:
        client.fundingSources.combinedInvestmentPeriodYears,
      combinedProjectedCostCoverage:
        client.fundingSources.combinedProjectedCostCoverage,
      combinedProjectedCostCoveragePercent:
        client.fundingSources.combinedProjectedCostCoveragePercent,
    }),
  },
};
